import React from "react";
import { Link } from "react-router-dom";


export default function CommunityInitiatives() {
  return (
    <>
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{
          backgroundImage: 'url("/img/banner/banner-Community.jpg")',
        }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Community initiatives</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Community initiatives</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row mt-n2-9">
            {/* Sidebar */}
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    <li>
                      <Link to="/skill-development">
                        Skill Development<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/education">
                        Education<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/health">
                        Health<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/abled">
                        Inclusion of Differently Abled
                        <i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/sports">
                        Sports<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li className="active">
                      <Link to="/community-initiatives">
                        Community Initiatives<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="/livelihoods">
                        Livelihoods<i className="ti-arrow-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>

                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Follow us</h2>
                  <div className="widget-content">
                    <ul className="social-icon-style2 list-unstyled ps-0">
                      <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                      <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                <div
                  className="mb-1-9 mb-lg-5 image-hover wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <img
                    src="/img/service/service-details-community.jpg"
                    alt="..."
                    className="border-radius-10"
                  />
                </div>
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  Always looking for opportunities to ensure the well-being of
                  its communities as well as forge closer ties with them,
                  Shamayita Math undertakes many other endeavors. These include
                  social welfare-related efforts comprising blood donation
                  camps, and distributing clothing items, and prosthetic aids
                  for the differently abled. It also honors the culture of the
                  local tribal community by celebrating the vibrant Kherwal
                  Tukou festival.
                </p>

                <h2
                  className="mb-4 wow fadeInUp text-primary pt-3"
                  data-wow-delay="100ms"
                >
                  Donation Drives:
                </h2>
                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/Community-1.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      Shamayita Math implements numerous humanitarian efforts
                      along with its core developmental activities. These
                      activities include regular organizing blood donation camps
                      such as the one held in July 2022 in which 70 people
                      donated blood, which was provided to the blood bank of
                      Bankura Sammelani Medical College.
                    </p>
                  </div>
                  <p className="mb-0">
                    Regular cloth donation drives for those in need are also
                    organized on the occasions such as Durga Puja, and Bengali
                    New Year. Besides, blankets are also distributed to
                    disadvantaged people. The Math also donates prosthetic aids
                    to numerous specially-abled individuals on occasion such as
                    World Disability Day.
                  </p>
                </div>

                <div className="row mt-n1-9">
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/Community-2.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/Community-3.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-4 mt-1-9 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/Community-4.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Celebration of Adivasi Culture at Kherwal Tukou Festival:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p className="mb-0">
                      Embracing the culture of its community, Shamayita Math
                      every year, on the 1st of January, celebrates the vibrant
                      Kherwal Tukou festival, a prominent event of the Adivasi
                      community in Bankura for over 25 years. The festival
                      exhibits the region's rich cultural heritage and is held
                      amidst the scenic surroundings with Susunia Hills forming
                      the beautiful backdrop in the picturesque tribal village
                      of Shiulibona. Each year thousands of villagers join the
                      daylong festivities, held in the honour and commemoration
                      of the Adivasi traditions. The festival provides an
                      opportunity for the local community to bond over dance,
                      music, and a delicious open-air lunch.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="/img/service/Community-5.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-n1-9">
                  <div className="col-md-4 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="image-hover">
                      <img src="img/service/Community-6.jpg" alt="..." className="border-radius-10" />
                    </div>
                  </div>

                  <div className="col-md-4 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="image-hover">
                      <img src="img/service/Community-7.jpg" alt="..." className="border-radius-10" />
                    </div>
                  </div>

                  <div className="col-md-4 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="image-hover">
                      <img src="img/service/Community-8.jpg" alt="..." className="border-radius-10" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
}
